import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBotComponent } from './chat-bot.component';
import { DirectivesModule } from '../directives/directives.module';
import { TranslationModule } from 'src/app/i18n/translation.module';

@NgModule({
  declarations: [
    ChatBotComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    TranslationModule
  ],
  exports: [ChatBotComponent]
})
export class ChatBotModule { }
